import 'core-js/es6';
import 'isomorphic-fetch';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';

//components
import AppRouter from './routes/app-router';

//styles
require('./../scss/main.scss');

//render
ReactDOM.render(<AppRouter />, document.getElementById('app'));
